<label class="app-checkbox" [style.--checkbox-size.px]="boxSize">
  <input
    type="checkbox"
    class="app-checkbox__input"
    [checked]="checked"
    (change)="onChange($event)"
  />
  <span class="app-checkbox__label">{{ label }}</span>
</label>
